export const EDUTAINMENT_PLACE_OPTIONS = [
  {
    label: '娛樂室',
    value: '娛樂室',
  },
  {
    label: '會議室',
    value: '會議室',
  },
  {
    label: '演播廳',
    value: '演播廳',
  },
];

export const DEFAULT_FIXED_TIME = {
  isDayChecked: false,
  startTime: null,
  endTime: null,
  place: null,
  address: null,
};
